<template>
  <div v-html="htmlContent" class="accessibility"></div>
</template>

<script>
export default {
  data() {
    return {
      htmlContent: ''
    };
  },
  mounted() {
    this.loadHtml();
  },
  watch: {
    '$i18n.locale': 'loadHtml'
  },
  methods: {
    loadHtml() {
      console.log('Loading HTML content for locale:', this.$i18n.locale);
      const url = `/html/accessibility_${this.$i18n.locale}.html`;

      fetch(url)
        .then(response => {
          if (!response.ok) {
            throw new Error(`Errore nel caricamento del file HTML: ${response.status}`);
          }
          return response.text();
        })
        .then(html => {
          this.htmlContent = html;
        })
        .catch(error => {
          console.error(error);
          this.htmlContent = '';
        });
    }
  }
};
</script>

<style scoped></style>